import { get } from 'lodash';

import {
  getLabelFontColor,
  getLabelFontSize,
  getLabelFontStyle,
  getLabelFontWeight,
  getLabelStickTo,
  getLabelTextDecoration,
  getLabelTextTransform,
  getSelectionColor,
  getStaticTextFontSize,
  getStaticTextFontFamily,
  getStaticTextFontColor,
  getStaticTextFontStyle,
  getStaticTextFontWeight,
  getStaticTextDecoration,
  getStaticTextTransform,
  getTextfieldBackgroundColor,
  getTextfieldBorderColor,
  getTextfieldBorderRadius,
  getTextfieldBorderStyle,
  getTextfieldBorderWidth,
  getTextfieldFontColor,
  getTextfieldFontSize,
  getTextfieldFontStyle,
  getTextfieldFontWeight,
  getTextfieldTextDecoration,
  getTextfieldTextTransform,
  getQuestionTextFontSize,
  getQuestionTextFontFamily,
  getQuestionTextFontColor,
  getQuestionTextFontStyle,
  getQuestionTextFontWeight,
  getQuestionTextDecoration,
  getQuestionTextTransform,
  getOptionTextFontSize,
  getOptionTextFontFamily,
  getOptionTextFontColor,
  getOptionTextFontStyle,
  getOptionTextFontWeight,
  getOptionTextDecoration,
  getOptionTextTransform,
  getButtonFontSize,
  getButtonFontColor,
  getButtonFontWeight,
  getButtonFontStyle,
  getButtonTextDecoration,
  getButtonTextTransform,
  getButtonBorderWidth,
  getButtonBorderStyle,
  getButtonBorderRadius,
  getButtonBorderColor,
  getButtonBackgroundColor,
  getPageBackgroundColor,
  getBodyBackgroundColor,
  getBodyBackgroundImage,
  getBodyBackgroundPosition,
  getBlockMargin,
} from './plain';
import {
  DEFAULT_SURVEY_STYLES_STATE_PATH,
  LOCAL_STYLING_STATE_PATH,
} from '../reducers';

const accumulateStyles = (blockData, localData, defaultData) =>
  blockData || localData || defaultData;

export const getDefaultSurveyStyles = state =>
  state[DEFAULT_SURVEY_STYLES_STATE_PATH];

export const getLocalStyling = state => state[LOCAL_STYLING_STATE_PATH];

export const getStylingSelectionColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getSelectionColor(state[LOCAL_STYLING_STATE_PATH]),
    getSelectionColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingStaticTextFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingStaticTextFontFamily = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextFontFamily(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextFontFamily(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingStaticTextFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingStaticTextFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingStaticTextFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingStaticTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingStaticTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getStaticTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getStaticTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingQuestionTextFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingQuestionTextFontFamily = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextFontFamily(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextFontFamily(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingQuestionTextFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingQuestionTextFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingQuestionTextFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingQuestionTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingQuestionTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getQuestionTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getQuestionTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingOptionTextFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingOptionTextFontFamily = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextFontFamily(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextFontFamily(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingOptionTextFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingOptionTextFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingOptionTextFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingOptionTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingOptionTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getOptionTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getOptionTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingButtonFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getButtonFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getButtonFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getButtonFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getButtonFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getButtonTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getButtonTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonBorderWidth = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonBorderWidth(state[LOCAL_STYLING_STATE_PATH]),
    getButtonBorderWidth(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonBorderStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonBorderStyle(state[LOCAL_STYLING_STATE_PATH]),
    getButtonBorderStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonBorderRadius = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonBorderRadius(state[LOCAL_STYLING_STATE_PATH]),
    getButtonBorderRadius(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonBorderColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonBorderColor(state[LOCAL_STYLING_STATE_PATH]),
    getButtonBorderColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );

export const getStylingButtonBackgroundColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getButtonBackgroundColor(state[LOCAL_STYLING_STATE_PATH]),
    getButtonBackgroundColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getLabelFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getLabelFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getLabelFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getLabelFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelStickTo = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelStickTo(state[LOCAL_STYLING_STATE_PATH]),
    getLabelStickTo(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getLabelTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingLabelTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getLabelTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getLabelTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldBackgroundColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldBackgroundColor(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldBackgroundColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldBorderColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldBorderColor(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldBorderColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldBorderRadius = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldBorderRadius(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldBorderRadius(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldBorderStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldBorderStyle(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldBorderStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldBorderWidth = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldBorderWidth(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldBorderWidth(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldFontColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldFontColor(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldFontColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldFontSize = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldFontSize(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldFontSize(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldFontStyle = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldFontStyle(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldFontStyle(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldFontWeight = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldFontWeight(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldFontWeight(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldTextDecoration = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldTextDecoration(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldTextDecoration(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingTextfieldTextTransform = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getTextfieldTextTransform(state[LOCAL_STYLING_STATE_PATH]),
    getTextfieldTextTransform(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingPageBackgroundColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getPageBackgroundColor(state[LOCAL_STYLING_STATE_PATH]),
    getPageBackgroundColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingBodyBackgroundColor = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getBodyBackgroundColor(state[LOCAL_STYLING_STATE_PATH]),
    getBodyBackgroundColor(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingBodyBackgroundImage = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getBodyBackgroundImage(state[LOCAL_STYLING_STATE_PATH]),
    getBodyBackgroundImage(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingBodyBackgroundImageId = (state, ownStyle) =>
  get(getStylingBodyBackgroundImage(state, ownStyle), 'id');
export const getStylingBodyBackgroundImageName = (state, ownStyle) =>
  get(getStylingBodyBackgroundImage(state, ownStyle), 'name');
export const getStylingBodyBackgroundImageUrl = (state, ownStyle) =>
  get(getStylingBodyBackgroundImage(state, ownStyle), 'url');
export const getStylingBodyBackgroundPosition = (state, ownStyle) =>
  accumulateStyles(
    ownStyle,
    getBodyBackgroundPosition(state[LOCAL_STYLING_STATE_PATH]),
    getBodyBackgroundPosition(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
export const getStylingBlockMargin = (state, ownStyles) =>
  accumulateStyles(
    ownStyles,
    getBlockMargin(state[LOCAL_STYLING_STATE_PATH]),
    getBlockMargin(state[DEFAULT_SURVEY_STYLES_STATE_PATH]),
  );
